import BaseClass from "../util/BaseClass";
import ReferenceLayer from "../aiim/base/ReferenceLayer";
import UserSettings from "../aiim/base/UserSettings";
import type QueryCriteria from "../spaceplanner/base/QueryCriteria";

export default class Session extends BaseClass {

  cfgState = {};
  cfServiceDescription;
  networkServiceInfo;
  referenceLayer: ReferenceLayer;
  selectedTravelModeID;
  startInConfiguratorMode;
  startupToast;
  userSettings: UserSettings;
  appDataHadWorkspaceConfig: boolean;
  queryCriteriaByKey: {
    [prop: string]: QueryCriteria
  };
  constructor(props?) {
    super(props);
    this.referenceLayer = new ReferenceLayer();
    this.userSettings = new UserSettings();
  }

  viewsReloading() {
    this.startupToast = null;
    this.referenceLayer = new ReferenceLayer();
  }

}
